<template>
  <div>
    <h1>Perfis O&M</h1>
    <SGPBotaoAdicionarNovoComponent @sgpAdiconarNovoEmit="adicionarNovoUsuario" style="z-index: 1000;"/>
    <SGPTabelaComponent
      v-if="listaDePerfis.length"
      :colunas="colunas"
      :dados="listagemPerfis"
      @sgpTabelaLinhasSelecionadasEmit="gerenciadorDeSelecionados"
      @sgpTabelaEditarSelecionadoEmit="editarSelecionado"
      @sgpTabelaDeletarSelecionadoEmit="deletarSelecionados"
    ></SGPTabelaComponent>

    <SGPAlertaComponent v-else></SGPAlertaComponent>

    <SGPModalComponent
      v-if="abrirModal"
      tamanho="sm"
      titulo="Perfil"
      @sgpModalFechar="fecharModal"
      :mostrarFooter="false"
    >
      <FormularioUsuarioComponent
        :tipoFormulario="tipoFormulario"
        :perfil="perfil"
      />
    </SGPModalComponent>

  
    <SGPConfirmacaoDelecaoComponent
      v-if="abrirModalDeletarDados"
      @sgpCancelarDelecaoEmit="cancelarDelecao()"
      @sgpConfirmarDelecaoEmit="confirmarDelecao()"
    />

    <SGPLoadingComponent v-if="loadingPerfil"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import FormularioUsuarioComponent from '../components/FormularioPerfilComponent.vue'
import deletar from "@/././common/mixins/deletar.js";

export default {
  components: { FormularioUsuarioComponent },
  name: 'PerfisPage',
  mixins: [deletar],
  data () {
    return {
      mostrarSelecionar: true,
      mostrarEditar: true,
      mostrarDeletar: true,
      perfisSelecionados: [],
      abrirModal: false,
      abrirModalDeletarDados: false,
      tipoFormulario: 'salvar',
      perfil: {}
    }
  },

  created () {
    this.listarPerfis();
  },

  computed: {
    ...mapGetters('perfis', ['listaDePerfis','loadingPerfil']),

    listagemPerfis () {
      return this.listaDePerfis || []
    },

    colunas () {
      return [
        {
          key: 'selecionar',
          label: 'Ações',
          sortable: false
        },
        {
          key: 'name',
          label: 'Nome',
          sortable: false,
          width: 200,
        },
        {
          key: 'description',
          label: 'Descrição',
          width: 500,
          sortable: false
        },
        {
          key: 'acl_sub_modulo.submodulo',
          label: 'Submódulo',
          sortable: false
        },
      ]
    }
  },

  methods: {
    ...mapActions('perfis', [
      'listarPerfis',
      'excluirPerfis'
    ]),

    gerenciadorDeSelecionados (selecionados) {
      this.perfisSelecionados = selecionados
    },

    adicionarNovoUsuario () {
      this.abrirModal = true
      this.tipoFormulario = 'salvar'
      this.perfil = {}
    },

    editarSelecionado () {
      this.tipoFormulario = 'editar'
      this.perfil = this.perfisSelecionados[0]
      this.abrirModal = true
    },

    confirmarDelecao () {
      this.excluirPerfis(this.perfisSelecionados);
      this.deletarDados = false;
    },

    fecharModal () {
      this.abrirModal = false
    }

  }
}
</script>